export const MEMBERS_WITH_ACCESS_COLOR = "#008559";
export const MEMBERS_WITHOUT_ACCESS_COLOR = "#CC3A52";

export const NETWORK_PROVIDER_COLOR = "#056edf";
export const PROSPECT_PROVIDER_COLOR = "#c75600";
export const MARKET_PROVIDER_COLOR = "#402294";
export const TARGET_PROVIDER_COLOR = "#FFD654";

export const NETWORK_PROVIDER_CARD_HIGHLIGHT_BACKGROUND_COLOR = "#DCECFF";
export const NETWORK_PROVIDER_CARD_HIGHLIGHT_BORDER_COLOR = "#056EDF";

export const IMPACT_PROVIDER_CARD_HIGHLIGHT_BACKGROUND_COLOR_SUCCESS = "#EBF5F2";
export const IMPACT_PROVIDER_CARD_HIGHLIGHT_BORDER_COLOR_SUCCESS = "#008559";

export const IMPACT_PROVIDER_CARD_HIGHLIGHT_BACKGROUND_COLOR_WARNING = "#FFFCF1";
export const IMPACT_PROVIDER_CARD_HIGHLIGHT_BORDER_COLOR_WARNING = "#FFD654";

export const IMPACT_PROVIDER_CARD_HIGHLIGHT_BACKGROUND_COLOR_DANGER = "#FBEFF1";
export const IMPACT_PROVIDER_CARD_HIGHLIGHT_BORDER_COLOR_DANGER = "#CC3A52";

export const PROVIDER_ACCORDION_BUTTON_COLOR = "#828282";

// Use a RGB color for these shadows to preserve the opacity
export const NETWORK_PROVIDER_ICON_SHADOW_COLOR = "rgba(100, 160, 220, 0.5)";
export const PROSPECT_PROVIDER_ICON_SHADOW_COLOR = "rgba(120, 50, 0, 0.5)";
export const MARKET_PROVIDER_ICON_SHADOW_COLOR = "rgba(180, 160, 255, 0.4)";
export const TARGET_PROVIDER_ICON_SHADOW_COLOR = "rgba(255, 215, 84, 0.51)";

export const DEFAULT_COLOR = "rgba(0, 0, 0, 0)";